export default __webpack_public_path__ + "static/media/AUSKUNFT.1e337116.png";